import { Observable } from 'rxjs';
import { fetchModelImageAnnotationListAPI } from '../../api/fetch-functions/model-image-annotation';
import { IAnnotationType } from '../../types/record/annotation';
import { ListWithPromiseState } from './common/list-with-status';
import {
  fetchIdsStreamGenerator,
  fetchListFnGenerator,
  listOfIdFnGenerator,
  twoIdListSetReducerGenerator,
  twoIdListSetStreamGenerator,
  updateStreamGenerator
} from './common/two-id-list';

const fetchSignal$ = fetchIdsStreamGenerator();

// 仮引数のリネームのためいったん変数`f`に格納
const f = fetchListFnGenerator(fetchSignal$);
export const fetchModelImageAnnotationListOf = (
  modelId: number,
  imageId: number
) => {
  f(modelId, imageId);
};

/**
 * @description
 * `fetchModelImageAnnotationListOf(modelId, imageId)` を実行すると
 * `modelImageAnnotationListSet$` の該当idの要素を re-fetch する．
 */
const updateModelImageAnnotationList$ = updateStreamGenerator(
  fetchSignal$,
  fetchModelImageAnnotationListAPI
);

const modelImageAnnotationListSetReducer = twoIdListSetReducerGenerator<
  IAnnotationType
>();

/**
 * @description
 * すべての modelImageAnnotationList の集合．必要になったものからfetchして蓄える．
 * 複数のcomponentで共有するため．
 */
const modelImageAnnotationListSet$ = twoIdListSetStreamGenerator(
  updateModelImageAnnotationList$,
  modelImageAnnotationListSetReducer
);

const g = listOfIdFnGenerator<IAnnotationType>(modelImageAnnotationListSet$);
export const modelImageAnnotationListOf = (
  modelId: number,
  imageId: number
): Observable<ListWithPromiseState<IAnnotationType>> => {
  fetchModelImageAnnotationListOf(modelId, imageId);
  return g(modelId, imageId);
};
